import React from "react";

import { Column, ColumnContainer, ColumnsContainer } from "../styles";
import { useOpticsStore } from "../../../../stores/use-optics-store";
import { macroStores } from "../../../../stores/export-stores";
import { MACRO_KEY } from "../../../defaults";
import {
  CARD_DESIGN,
  CARD_DESIGN_COLUMNS,
} from "../../drawers/settings/features/cards/defaults";

const STATE_KEYS = {
  [MACRO_KEY.CARDS]: {
    dataKey: "data",
    updateConfigKey: "updateCardsConfig",
    columnsKey: "columns",
    standaloneConfig: false,
  },
  [MACRO_KEY.ANNOUNCEMENTS]: {
    dataKey: "data",
    updateConfigKey: "updateConfig",
    columnsKey: "columns",
    standaloneConfig: true,
  },
};

const NUMBER_OF_COLUMNS = {
  [MACRO_KEY.CARDS]: [1, 2, 3, 4, 5],
  [MACRO_KEY.ANNOUNCEMENTS]: [1, 2],
  [undefined]: [],
};

const getNumberOfColumns = (macro, config) => {
  if (macro === MACRO_KEY.CARDS) {
    return CARD_DESIGN_COLUMNS[config?.design] || CARD_DESIGN_COLUMNS.DEFAULT;
  }

  return NUMBER_OF_COLUMNS[macro] ?? [];
};

const Columns = () => {
  const macro = useOpticsStore((state) => state.macro);
  const state = macroStores[macro]?.();
  const stateKeys = STATE_KEYS[macro];

  const [data, updateConfig, columnsKey, standaloneConfig] = [
    state[stateKeys?.dataKey],
    state[stateKeys?.updateConfigKey],
    stateKeys?.columnsKey,
    stateKeys?.standaloneConfig,
  ];

  if (!data?.length) return <></>;

  const config = standaloneConfig ? state?.config : data?.[0]?.config;
  const columns = getNumberOfColumns(macro, config);

  return (
    <ColumnsContainer numberOfColumns={columns.length}>
      {columns.map((columns) => (
        <ColumnContainer
          key={columns}
          columns={columns}
          active={columns === config[columnsKey]}
          onClick={() => updateConfig?.({ key: columnsKey, value: columns })}
        >
          {Array.from({ length: columns }, (_, index) => (
            <Column key={index} active={columns === config[columnsKey]} />
          ))}
        </ColumnContainer>
      ))}
    </ColumnsContainer>
  );
};

export default Columns;
